/* esm.sh - mainnet-js@4.0.0-next.4/dist/module/chain */
var n={subUnits:100000000n};export{n as bchParam};
//# sourceMappingURL=chain.mjs.map